module.exports = __webpack_public_path__ + "media/images/svg/youtube-5b03351fa954ad60ae2ac3bf15d8c42b.svg";